import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | null = null;
const isDev = import.meta.env.DEV;

export function initAppInsights(connectionString?: string): void {
  if (!connectionString) {
    if (isDev) console.warn("[Telemetry] No connection string — App Insights disabled");
    return;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      disableFetchTracking: false,
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((item) => {
    item.tags = item.tags ?? [];
    item.tags["ai.cloud.role"] = "Optimyl.EmployerIntake.UI";
  });
}

export function setAuthenticatedUser(userId: string, accountId?: string): void {
  appInsights?.setAuthenticatedUserContext(userId, accountId, true);
}

export function clearAuthenticatedUser(): void {
  appInsights?.clearAuthenticatedUserContext();
}

export function trackEvent(name: string, properties?: Record<string, string>): void {
  appInsights?.trackEvent({ name }, properties);
  if (isDev) console.debug("[Telemetry] Event:", name, properties);
}

export function trackError(error: Error, properties?: Record<string, string>): void {
  appInsights?.trackException({ exception: error }, properties);
  if (isDev) console.error("[Telemetry] Exception:", error.message, properties);
}

export function trackWarning(message: string, properties?: Record<string, string>): void {
  appInsights?.trackTrace({ message, severityLevel: 2 }, properties);
  if (isDev) console.warn("[Telemetry] Warning:", message, properties);
}

export function trackPageView(name: string): void {
  appInsights?.trackPageView({ name });
}
